export default __webpack_public_path__ + "static/media/analysis_in_progress.f94e5881.svg";